/**
 * Handle task PUT response when assignee submitted a pending done request.
 * @returns {boolean} true if a pending-done request was created (caller should skip generic success toast)
 */
export function handlePendingDoneRequestResponse(data, toast) {
  if (data?.pendingDoneRequest) {
    toast.success(
      data.message ||
        'Completion request sent to the task creator for review.',
      { duration: 5000 },
    );
    return true;
  }
  return false;
}
